import { baseApi } from './baseApi';
import { EvaluationTemplateModel } from '../models/evaluationTemplateModel';

export async function getEvaluationTemplatesReq() {
  return baseApi.get('/officiating/evaluation-templates');
}

export async function createEvaluationTemplateReq(
  evaluationTemplate: EvaluationTemplateModel,
  evaluationTemplateFile?: File,
) {
  const data = new FormData();
  if (evaluationTemplateFile) data.append('file', evaluationTemplateFile);
  data.append('evaluationTemplate', JSON.stringify(evaluationTemplate));
  return baseApi.post('/officiating/evaluation-templates', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function deleteEvaluationTemplateReq(evaluationTemplateId: string) {
  return baseApi.delete(`/officiating/evaluation-templates/${evaluationTemplateId}`);
}
